import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    this.revealBanner = this.revealBanner.bind(this)

    window.addEventListener("listings-page-mounted", this.revealBanner, { once: true })
  }

  disconnect() {
    window.removeEventListener("listings-page-mounted", this.revealBanner)
  }

  revealBanner() {
    this.bannerTarget.classList.remove("hidden", "invisible", "banner-initially-hidden")
  }
}
